import type { ModulRow } from '../../data/modul'
import type { ViewConfig } from '@/core/views/viewConfig'

function usageText(count: number): string {
  if (count === 0) return "Nicht verwendet"
  return (count === 1 ? `in ${count} Maßnahme verwendet` : `in ${count} Maßnahmen verwendet`)
}

export const moduleViewConfig: ViewConfig<ModulRow> = {
  rowKey: (m) => m.id,
  title: (m) => m.name,
  cards: true,
  emptyText: "Keine Module konfiguriert",
  sortKeys: [{ key: 'name', label: "Name", accessor: (m) => m.name }],
  searchFields: (m) => [m.name],
  filterCategories: [{ id: 'usage', label: "Verwendung", catalog: () => [{ key: 'used', label: "In Maßnahmen verwendet" }, { key: 'unused', label: "Nicht verwendet" }], accessor: () => [] }],
}

export function moduleViewConfigWithUsage(usage: Map<string, number> | null): ViewConfig<ModulRow> {
  return {
    ...moduleViewConfig,
    filterCategories: usage ? moduleViewConfig.filterCategories!.map((category) => ({ ...category, accessor: (m: ModulRow) => (usage.get(m.id) ?? 0) > 0 ? 'used' : 'unused' })) : undefined,
    properties: [{ id: 'usage', value: (m: ModulRow) => usage ? usageText(usage.get(m.id) ?? 0) : "Verwendung unbekannt" }],
  }
}
